export const googleMapsLink = (latitude: number, longitude: number): string =>
  `https://www.google.com/maps?q=${latitude},${longitude}`

// `/place` renders a red marker at the queried coordinates, whereas `/view`
// only centers the map without a pin — use `/place` so the event location is
// explicitly marked.
export const googleMapsEmbedSrc = (latitude: number, longitude: number, apiKey: string, zoom = 17): string =>
  `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${latitude},${longitude}&zoom=${zoom}`
